import { Component } from '@angular/core';
import { ApiService } from 'src/app/Services/Api/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-institucional',
  templateUrl: './institucional.component.html',
  styleUrls: ['./institucional.component.css'],
})
export class InstitucionalComponent {
  sedes: any[] = [];

  constructor(private _apiService: ApiService) {
    _apiService.get('sede').then((data) => {
      this.sedes = [
        ...data.sedes.map((sede: any) => ({
          id: sede.rutaSede,
          title: sede.nombre,
          class1: 'white-bold',
          title2: 'Dirección: ' + sede.direccion,
          class2: 'negrilla white',
          dataTitle2: '',
          additionalTittle: sede.horarios,
          additionalData: '',
          imagen: environment.backendURL + '/publico/imagenes/6/' + sede.imagen,
          rutaSede: sede.rutaSede,
        })),
      ];
      this.getHtml();
    });
  }

  navbarOpen = false;

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  getHtml() {
    this.sedes.forEach((sede, index: number) => ({
      ...this.sedes,
      html: this._apiService.get('raw/6/' + sede.rutaSede).then((data: any) => {
        this.sedes[index].html = data.contenido;
      }),
    }));
  }
}
